import request from '@/utils/request'

// export const getdatalist = (params: any) =>
//   request({
//     url: '/api/geteqamangelist',
//     method: 'get',
//     params
//   })
export const getdatalist = (params: any) =>
  request({
    url: '/deviceReview/getDeviceReviewInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
// export const getecharttimeData = (params: any) =>
//   request({
//     url: '/api/geteqamangelist/:id',
//     method: 'get',
//     params
//   })
export const getecharttimeData = (params: any) =>
  request({
    url: '/deviceReview/getPicDataById',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
